const clientLoanResolver = (data = {}) => {
  return {
    cashReserve: data.client.loan_information.cash_reserve,
    initialAdvance: data.client.loan_information.loan_amount,
    useCashReserve: data.client.loan_information.use_cash_reserve_feature,
  };
};

export default clientLoanResolver;
